import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/user/equity.png'


const _withScopeId = n => (_pushScopeId("data-v-2c6e7acf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "noVip"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "vipInfo"
}
const _hoisted_9 = { class: "vipInfo-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "本月已用次数", -1))
const _hoisted_11 = { class: "vipInfo-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "本月剩余次数", -1))

import { computed, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import day from 'dayjs'
import { ServiceStatusType } from '@/const/user'
import avatarImg from '@/assets/images/user/default-avatar.png'
import * as trackStore from '@/trace/xesTrackVip'


export default /*#__PURE__*/_defineComponent({
  __name: 'userMember',
  props: {
  pageName: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props;

const store = useStore()


// 埋点变更，该模块改为统一埋点，每个模块均上报
const track = trackStore['pcpaper']

const userInfo = computed(() => store.state.user.userInfo)
const requestDone = computed(() => store.state.user.requestDone)
const paperVipInfo = computed(() => store.getters['user/paperVipInfo'])
const vip = computed(
  () => paperVipInfo.value?.use_status === ServiceStatusType['已开通']
)

const commonTrackParams = () => {
  return {
    is_login: userInfo.value ? '是' : '否',
    is_vip: vip.value ? '是' : '否',
    entrance: props.pageName
  }
}

const goLogin = () => {
  store.dispatch('openLogin')
}

const openVipDialog = () => {
  store.dispatch('openVipDialog', {
    position: '右侧购买会员',
    entrance: props.pageName
  })
  track && track.clickOpenvip({ ...commonTrackParams() })
}
const formatTime = () => {
  return day.unix(paperVipInfo.value?.service_expired_time).format('YYYY-MM-DD')
}

const trackShow = () => {
  if (requestDone.value.getUserInfo && requestDone.value.getUserServiceStatus) {
    track && track.show({ ...commonTrackParams() })
  }
}

watch(
  () => requestDone.value,
  () => {
    trackShow()
  },
  {
    deep: true
  }
)

onMounted(() => {
  trackShow()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: userInfo.value?.avatar_url || _unref(avatarImg),
        alt: "",
        srcset: ""
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", {
          class: _normalizeClass([vip.value && 'tag'])
        }, [
          (userInfo.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(userInfo.value?.nickname), 1))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                onClick: goLogin,
                class: "login"
              }, "立即登录"))
        ], 2),
        _createElementVNode("p", null, _toDisplayString(vip.value ? `到期日期:${formatTime()}` : '开通会员，下载试卷最低￥0.4/份'), 1)
      ])
    ]),
    (!userInfo.value || !vip.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("p", null, _toDisplayString(paperVipInfo.value.remain_use || 0) + "次", 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("p", null, _toDisplayString(paperVipInfo.value.remain_download >= 0
              ? paperVipInfo.value.remain_download
              : '无限') + "次 ", 1)
          ])
        ]))
  ]))
}
}

})